export default function immoCollapsible() {
    const toggleButtons = document.querySelectorAll('.i-js-collapsible-toggle');

    toggleButtons.forEach((toggleButton) => {
        toggleButton.addEventListener('click', () => {
            const parent = toggleButton.closest('.i-js-collapsible');
            parent.classList.toggle('is-collapsed');
        });
    });
}
